import React from "react";
import { Box, Typography } from "@mui/material";
import { formatWaivedAmountFromPrevious } from "../../utils/feeWaiverDisplay";

export interface FeeWaiverAmountDetailsProps {
  previousAmount: number;
  currentAmount: number;
  formatAmount: (amount: number) => string;
  /** Include `{label}: {current}` heading (save-confirm popups / payment breakdown). */
  showFeeLine?: boolean;
  feeLabel?: string;
}

const FeeWaiverAmountDetails: React.FC<FeeWaiverAmountDetailsProps> = ({
  previousAmount,
  currentAmount,
  formatAmount,
  showFeeLine = false,
  feeLabel,
}) => {
  const waivedDisplay = formatWaivedAmountFromPrevious(
    previousAmount,
    currentAmount,
    formatAmount,
  );

  return (
    <>
      {showFeeLine && feeLabel ? (
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: "text.primary", mb: 0.25 }}
        >
          {feeLabel}: {formatAmount(currentAmount)}
        </Typography>
      ) : null}
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
        Previous Amount:{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
          {formatAmount(previousAmount)}
        </Box>
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        Waived Amount:{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "error.main" }}>
          {waivedDisplay}
        </Box>
      </Typography>
    </>
  );
};

export default FeeWaiverAmountDetails;
